import styled, { css } from 'styled-components';

const colorCss = css`
  background-color: ${({ theme }) => theme.colors.gray300};
  border-radius: 4px;
`;

export const S = {
  Wrapper: styled.nav`
    display: flex;
    gap: 30px;
    margin: 0 auto;
    align-items: center;

    padding-bottom: 20px;

    ${({ theme }) => theme.media.pc} {
      width: 1136px;
    }
    ${({ theme }) => theme.media.tablet} {
      padding-left: 32px;
      padding-right: 32px;
    }

    ${({ theme }) => theme.media.mobile} {
      padding-left: 20px;
      padding-right: 20px;
    }
    div {
      width: 55px;
      height: 35px;

      ${colorCss};
    }
  `,
};
